import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    success: false,
    successPayload: {
      title: '',
      top: '',
      bottom: ''
    },
    blurNav: false,
    modalOpen: false,
    selectedVehicle: '',
    ttl: '',
    sub: '',
    active: '',
    mail_templates: { ...JSON.parse(process.env.VUE_APP_MAIL_TEMPLATES) },
    navHeight: 1,
    prices: {},
    selectedStation: '',
    openSchedule: false,
  },
  getters: {
    mailTemplate: state => form => {
      return state.mail_templates[form] || null;
    },
    approxPrice: state => val => {
      const value = state.prices[val]?.outright;
      // console.log(value);

      return Math.floor(value / 1000000) || 0
    },
    orderPrice: state => val => {

      return { ...state.prices[val] }
    },
    dispPrices: (state, getters) => {
      const vehicles = ["panther", "savannah", "sill", "caspian", "sable", "javan"];
      // console.log(value);

      return vehicles.reduce((acc, vah) => {
        acc[vah] = getters.approxPrice(vah);
        return acc;
      }, {});
    },
    downPayment: state => {
      return parseFloat(state.prices.downpayment) || 0;
    },
    monthlyRepayment: state => ({ outright, downpayment, tenor }) => {
      // console.log(outright, downpayment, tenor);

      const monthlyRate = 0.35 / 12;
      const presentValue = outright - downpayment;
      const tenorInMonths = tenor * 12;
      const denominator = 1 - Math.pow(1 + monthlyRate, -tenorInMonths);
      // console.log(outright);
      // console.log(downpayment);
      // console.log(tenor);
      // console.log(denominator);

      return ((monthlyRate * presentValue) / denominator).toFixed(2);
    },
    isOpen: _ => (openHours) => {
      const currentTime = new Date();
      const currentDay = currentTime.getDay(); // 0 = Sunday, 1 = Monday, ..., 6 = Saturday
      const openTime = new Date();
      const closeTime = new Date();

      // Convert "8am", "9:30pm" => { hours: Number, minutes: Number }
      const parseTime = (timeStr) => {
        const time = timeStr.toLowerCase().trim();
        const match = time.match(/(\d{1,2})(?::(\d{2}))?(am|pm)/);
        if (!match) return { hours: 0, minutes: 0 };

        let hours = parseInt(match[1]);
        const minutes = parseInt(match[2] || "0");
        const period = match[3];

        if (period === "pm" && hours !== 12) hours += 12;
        if (period === "am" && hours === 12) hours = 0;

        return { hours, minutes };
      };

      // Format time (Date or hours+minutes) to "5:00 PM"
      const formatTime = (hours, minutes) => {
        const date = new Date();
        date.setHours(hours, minutes, 0);
        return date.toLocaleTimeString("en-US", {
          hour: "numeric",
          minute: "2-digit",
          hour12: true,
        });
      };

      const scheduleText = openHours || "";
      const schedules = scheduleText.split(",").map((entry) => entry.trim());

      let schedule = null;

      for (const entry of schedules) {
        if (
          entry.includes("Mondays - Fridays") &&
          currentDay >= 1 &&
          currentDay <= 5
        ) {
          const times = entry.split(":")[1].trim().split(" - ");
          schedule = { open: times[0], close: times[1] };
          break;
        } else if (entry.includes("Saturdays") && currentDay === 6) {
          const times = entry.split(":")[1].trim().split(" - ");
          schedule = { open: times[0], close: times[1] };
          break;
        }
      }

      if (!schedule) {
        return { isOpen: false, text: "Closed today" };
      }

      const { hours: openHour, minutes: openMinute } = parseTime(schedule.open);
      const { hours: closeHour, minutes: closeMinute } = parseTime(
        schedule.close
      );

      openTime.setHours(openHour, openMinute, 0);
      closeTime.setHours(closeHour, closeMinute, 0);

      const openFormatted = formatTime(openHour, openMinute);
      const closeFormatted = formatTime(closeHour, closeMinute);

      if (currentTime >= openTime && currentTime <= closeTime) {
        return { isOpen: true, text: `Closes by ${closeFormatted}` };
      } else {
        return { isOpen: false, text: `Opens by ${openFormatted}` };
      }
    },
    isScheduleOpen: state => {
      return state.openSchedule;
    },
    selectedStation: state => {
      return state.selectedStation;
    }
  },
  mutations: {
    setBlur(state, value) {
      state.blurNav = value;
    },
    setModal(state, value) {
      state.modalOpen = value;
    },
    setVehicle(state, value) {
      state.selectedVehicle = value;
    },
    setTtl(state, value) {
      state.ttl = value;
    },
    setSub(state, value) {
      state.sub = value;
    },
    setActive(state, value) {
      state.active = value;
    },
    setSuccess(state, value) {
      state.success = value;
    },
    setSuccessP(state, value) {
      state.successPayload = value;
    },
    SetNavHeight(state, value) {
      state.navHeight = value;
    },
    SetPrices(state, value) {
      state.prices = value;
    },
    setSelectedStation(state, value) {
      state.selectedStation = value;
    },
    setOpenSchedule(state, value) {
      state.openSchedule = value;
    }
  },
  actions: {
    async sendMail({ getters }, { form, payload }) {
      // console.log(process.env.VUE_APP_MAIL_TEMPLATES);
      // return
      var template = getters.mailTemplate(form);
      // console.log(template);
      // console.log(payload);
      var body = {
        service_id: form === "panther_order" ? process.env.VUE_APP_SALES_SERVICE_ID : process.env.VUE_APP_SERVICE_ID,
        template_id: template,
        user_id: process.env.VUE_APP_PUBLIC_KEY,
        template_params: JSON.parse(JSON.stringify(payload)),
      }
      // console.log(body);
      await fetch(process.env.VUE_APP_MAIL_URL, {
        method: "POST",
        body: JSON.stringify(body),
        headers: { "Content-Type": "application/json" },
      })
        // .then((res) => res.json())
        .then((resp) => {
          return true;
        }).catch(err => {
          console.log(err);
          return false
        })
    },
    orderNow({ commit }, veh) {
      commit('setVehicle', veh);
      commit('setActive', 'order');
      commit('setTtl', `Order a ${veh} Now`);
      commit('setSub', "Requires a minimum of 60 days to deliver");
      commit('setModal', true);
    },
    scheduleNow({ commit }) {
      commit('setVehicle', '');
      commit('setActive', 'schedule');
      commit('setTtl', "Shedule Charge");
      commit('setSub', "");
      commit('setModal', true);
    },
    contactUs({ commit }) {
      commit('setVehicle', '');
      commit('setActive', 'contact');
      commit('setTtl', "Contact Us");
      commit('setSub', "");
      commit('setModal', true);
    },
    partnerNow({ commit }) {
      commit('setVehicle', '');
      commit('setActive', 'partner');
      commit('setTtl', "Become a Charge Partner");
      commit('setSub', "");
      commit('setModal', true);
    },
    closeModal({ commit }) {
      commit('setVehicle', '');
      commit('setActive', '');
      commit('setTtl', "");
      commit('setSub', "");
      commit('setModal', false);
    },
    modalSuccess(context, payload) {
      context.commit('setSuccessP', payload);
      context.dispatch('closeModal');
      context.commit('setSuccess', true);
    },
    closeSuccess(context) {
      context.commit('setSuccess', false)
      context.commit('setSuccessP', {
        title: '',
        top: '',
        bottom: ''
      });
      context.dispatch('closeModal');
    },
    openSchedule({ commit }, value) {
      commit('setSelectedStation', value);
      commit('setOpenSchedule', true);
    },
  },
  modules: {
  }
})
